var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHv1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1084.33 988.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#006300;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 659.79,
    y1: 683.22,
    x2: 1077.12,
    y2: 788.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#8ac758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#72b852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#3b9745"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1092.66,
    y1: 796.39,
    x2: 1453.51,
    y2: 887.47,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M740.14,399.18l-18.08,55.88q-35.64,107.59-66.32,214.47-14.81,51.71-44.93,180.24c-7.75,47.11-13.49,83.2-17,105.5-5,31.65-6.63,42.67-15.31,51.65-27.49,28.42-92.14,1.82-109.1-5.58q-.54,0-18.09-7-31.24-16.77-31.24-69.85,0-38.41,17.26-140.4t50.16-253.56Q562,192.47,599.87,112.83q12-27.26,30.41-42.26t50.13-23.4q30.69-8.39,70.69-8.39,37.27,0,52.36,12.23t15.07,42.26q0,28.64-19.73,107.21T740.14,399.18Z",
    transform: "translate(-420.06 -38.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1173.65,400.76l-18.08,55.88q-35.64,107.6-66.32,214.47-14.8,51.71-44.94,180.24c-7.74,47.11-13.49,83.2-17,105.5-5,31.65-6.63,42.67-15.31,51.65-27.49,28.42-92.15,1.82-109.1-5.58q-.55,0-18.09-7-31.24-16.77-31.25-69.85,0-38.42,17.27-140.4T921,532.12q74.55-338.07,112.39-417.71,12-27.25,30.4-42.26t50.14-23.4q30.67-8.39,70.69-8.39,37.28,0,52.36,12.23T1252,94.85q0,28.64-19.73,107.21T1173.65,400.76Z",
    transform: "translate(-420.06 -38.78)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M953.16,628.57c-7.53-10-67.62-88.17-140.32-81.78C710.9,555.76,656,724.55,652,722.19s36.45-191.44,170-220.43C904.6,483.81,973,538,979.39,543.24c96.26,78.73,115.88,259.93,39.93,448-5.63,16.55-9.09,20.18-11.28,19.88C991,1008.81,1058.89,769.76,953.16,628.57Z",
    transform: "translate(-420.06 -38.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1061.53,999.52c-23-15.48,1.23-114.82,50.2-187.26,55.88-82.66,133.38-114.62,155.15-123.25,10.54-4.18.38.49,168.84-23.7,26.23-3.77,56.66-8.22,66.17,7.11,6.1,9.84.56,23-11.41,54.51-29.61,78-21.53,65.52-32,87.7-23.48,50-50.16,106.82-109.51,151.7-55.09,41.66-119.64,58.92-157.44,59.26-14.14.13-33.81-2-70.73,0-25,1.37-37.71,3.56-38.78,0-1.77-5.86,30.61-18.47,77.57-47.41,0,0,17.87-11,52.48-35.55,88.52-62.77,237-230.44,232.72-234.66-1.34-1.34-16,15.92-75.29,68.74-30.77,27.42-58.2,50.26-111.8,94.81-43.3,36-80.32,66.26-132.33,99.55C1074.71,1003.52,1066.25,1002.69,1061.53,999.52Z",
    transform: "translate(-420.06 -38.78)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHv1);
export default __webpack_public_path__ + "static/media/hv1.8f2132899e70f4c59cc40b649270e37d.svg";
export { ForwardRef as ReactComponent };